<template>
  <div style="flex: 1">
    <div v-if="disActive" class="group-vanbtn disActive">
      活动已结束
    </div>
    <div v-else @click="clickBtn()" style="background: #EBEBEB;line-height: unset;margin: 5px 0;"
         class="group-vanbtn" :class="{activeappoint:form.courseButtonType==12||form.courseButtonType==13}">
      <template
          v-if="form.courseButtonType == 10">
        <span style="display: flex;align-items: center">
          <img style="width: 20px" src="./img/time.png" alt="">
          <span style="color: #828282;margin-left: 6px">敬请期待</span>
        </span>
        <span style="color: #828282;font-size: 12px;display: flex">
          <template v-if="milliseconds==0">
            {{ DJS }}
          </template>
          <template v-else>
            <span>距离开售还剩</span>
            <CountDown style="color: #828282;" :time="milliseconds"/>
          </template>
        </span>
      </template
      >
      <template
          v-if="form.courseButtonType == 11"
      >
        <span style="display: flex;align-items: center">
          <img style="width: 20px" src="./img/time.png" alt="">
          <span style="color: #828282;margin-left: 6px">敬请期待</span>
        </span>
        <span style="color: #828282;font-size: 12px;display: flex">请关注护士加课程上线通知</span>
      </template>
      <template
          v-if="form.courseButtonType == 12"
      >
        <span style="display: flex;align-items: center">
          <img style="width: 16px" src="./img/notification.png" alt="">
          <span style="color: #3D3D3D;margin-left: 6px">{{  form.courseAppointmentConfigVO.remark1 }}</span>
        </span>
        <span style="color: #3D3D3D;font-size: 12px;display: flex;align-items: center;">
        <template v-if="milliseconds==0">
            {{ DJS }}
          </template>
          <template v-else>
            <span style="position: relative;top: -2px">距离开售还剩</span>
            <CountDown @finish="$emit('ok')" style="color: #3D3D3D;font-size: 12px;margin-left: 4px" :time="milliseconds"/>
          </template>
      </span>
      </template>
      <template
          v-if="form.courseButtonType == 13"
      >
        <span style="display: flex;align-items: center">
<!--          <img style="width: 16px" src="./img/notification.png" alt="">-->
          <span style="color: #543C30;margin-left: 6px">
            {{  form.courseAppointmentConfigVO.remark1 }}
          </span>
          <OfflineTime @ok="disActive=true" :time="form.offlineTime" v-if="form.offlineTime"/>
        </span>
      </template>
      <template
          v-if="form.courseButtonType == 14"
      >
        <span style="display: flex;align-items: center">
          <img style="width: 16px" src="./img/notification-1.png" alt="">
          <span style="color: #828282;margin-left: 6px">{{  form.courseAppointmentConfigVO.remark2 }}</span>
        </span>
        <span style="color: #828282;font-size: 12px;display: flex">{{  form.courseAppointmentConfigVO.remark3 }}</span>
      </template>
    </div>
    <InfoCollection ref="infoCollectionRef" @submitOk="yy"/>
  </div>
</template>
<script>
import ButtonImgText from "./ButtonImgText.vue";
import {Toast, Button as VanButton, CountDown} from "vant";
import {appointment, cancelAppointment} from "@/api/collect.js";
import Telephone from "../../../components/Telephone/Telephone.vue";
import Coupon from "./Coupon.vue"
import moment from "moment";
import {isClient} from "@/utils/isTerminal";
import InfoCollection from "@/pages/courseDetails/component/infoCollection/InfoCollection.vue";
import OfflineTime from "@/pages/shareCourse/OfflineTime.vue";
import {hsjH5BurialPoint} from "@/utils/shareCommon";


export default {
  name: "Appointment",
  components: {OfflineTime, InfoCollection, ButtonImgText, VanButton, Telephone, Coupon, CountDown},
  props: {
    form: {
      type: Object,
      default: () => {
      }
    },
    isLogin: {
      // 是否登录
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      disActive:false,
      milliseconds: 0,
    };
  },
  mounted() {
    const currentTime = moment();
    const offlineTime = this.form.offlineTime;
    const futureTime = moment(offlineTime, "YYYY-MM-DD HH:mm:ss");
    const duration = moment.duration(futureTime.diff(currentTime));
    const milliseconds = duration.asMilliseconds()
    if (milliseconds<=0){
      this.disActive = true
    }
  },
  computed: {
    DJS: function () {
      if (this.form.courseButtonType == 10 || this.form.courseButtonType == 12) {
        const currentTime = moment();
        const onlineTime = this.form.onlineTime;
        const futureTime = moment(onlineTime, "YYYY-MM-DD HH:mm:ss");
        const duration = moment.duration(futureTime.diff(currentTime));
        const days = Math.floor(duration.asDays());

        if (days === 0) {
          this.milliseconds = duration.asMilliseconds()
          return ""
        }
        return `距离开售还剩${days}天`
      }
      return ""
    }
  },
  methods: {
    clickBtn(){
      hsjH5BurialPoint("B000026X", "B000026X-001", {
        id: PAGE_PARAMS.courseId
      });
      if(!this.isLogin){
        Toast("正在登录中，请稍后")
        this.$emit("login")//网页版h5使用
        return
      }
      let courseId = this.form.id
      let courseName = this.form.name

      let params = {courseId, courseName,}
      if(!isClient){
        let { sourceUserId,shareSource } = window.PAGE_PARAMS
        params.shareUserId = sourceUserId
        params.appointmentChannel = shareSource
      }else {
        params.appointmentChannel = "App"
      }


      if(this.form.courseButtonType==12||this.form.courseButtonType==13){
        //预约的时候先确认看看需不需要填写表单
        let info = this.form.courseUserInformationCollectionTemplateConfigVO
        if(info && info.userInformationCollectionTemplateVO){
          this.$refs.infoCollectionRef.Show(params,info.userInformationCollectionTemplateVO)
          return;
        }
        this.yy(params)
      }
      // if(this.form.courseButtonType==14){
      //   cancelAppointment({courseId, courseName}).then(()=>{
      //     Toast("已取消提醒，课程上线后您将不会收到提醒",{duration:2000})
      //     setTimeout(()=>{
      //       this.$emit("ok")
      //     },1800)
      //   })
      // }
    },
    yy(params,userInformationId=null){
      appointment({...params,userInformationId}).then(()=>{
        // Toast("预约成功，课程上线后我们将向您发送提醒",{duration:2000})
        setTimeout(()=>{
          this.$emit("ok")
        },1800)
      })
    }
  }
};
</script>

<style lang="scss" scoped>

.group-vanbtn {
  flex: 1;
  height: 50px;
  background: linear-gradient(
          -58deg,
          rgba(255, 102, 102, 1) 0%,
          rgba(255, 68, 68, 1) 100%
  );
  border-radius: 25px;
  font-size: 18px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 0;

  span {
    margin-top: 2px;
  }

  .deltip {
    display: block;
    font-size: 10px;
    font-weight: normal;
    margin-top: 16px;
  }
}
.activeappoint{
  background:#F3C458!important;
}
.disActive{
  pointer-events: none;
  background: #EBEBEB;
  color: #543C30;
}
</style>
